import { render, staticRenderFns } from "./WholeCalendarGantt.vue?vue&type=template&id=783f1f71"
import script from "./WholeCalendarGantt.vue?vue&type=script&lang=js"
export * from "./WholeCalendarGantt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports